// extracted by mini-css-extract-plugin
module.exports = {"icon":"like-styles_icon__wK8Y9"};